import { render, staticRenderFns } from "./AverageRatings.vue?vue&type=template&id=80c24058&"
import script from "./AverageRatings.vue?vue&type=script&lang=js&"
export * from "./AverageRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports